import React, { useState } from 'react'
import { Button, Form, Image, } from "react-bootstrap";

const ProductCategories = () => {
  const labels = ['Doppatas', 'Gharara/Sharara', 'Lahanga Choli', 'Maxi', 'Saree', 'Shirt Trouser', 'New Arrivals', 'All Product'];
  const [selectedOption, setSelectedOption] = useState(null);

  const handleRadioChange = (event) => {
    setSelectedOption(event.target.value);
  };

  return (
    <div>
      <h2>CATEGORIES</h2>
      {labels.map((label, index) => (
        <div key={index}>
          <label>
            <input
              type="radio"
              name="options"
              value={label}
              checked={selectedOption === label}
              onChange={handleRadioChange}
            />
             {label}
          </label>
        </div>
      ))}
    </div>
  );
};


export default ProductCategories